import { render, staticRenderFns } from "./dialogDetail.vue?vue&type=template&id=1830dbd0&scoped=true&"
import script from "./dialogDetail.vue?vue&type=script&lang=ts&"
export * from "./dialogDetail.vue?vue&type=script&lang=ts&"
import style0 from "./dialogDetail.vue?vue&type=style&index=0&id=1830dbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830dbd0",
  null
  
)

export default component.exports